import api from "../../../api/axios";

// Deal-eligible CRM clients for propose / start-internal pickers.
// Server filter: writable=true + type buyer|both. Do not treat
// client-side filtering as the security boundary.

const DEFAULT_PAGE_SIZE = 20;

export const searchDealEligibleClients = (params = {}, { signal } = {}) => {
  const {
    search,
    page = 1,
    page_size = DEFAULT_PAGE_SIZE,
  } = params;
  const query = {
    page,
    page_size,
    ordering: "-created_at",
    writable: true,
    type: ["buyer", "both"],
  };
  if (search && String(search).trim()) {
    query.search = String(search).trim();
  }
  return api.get("/crm/clients/", { params: query, signal }).then((res) => res.data);
};

export const unwrapPagedResults = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};

/** Safe picker label — name + type only; no phone/email PII. */
export const clientPickerLabel = (client) => {
  if (!client) return "";
  const name =
    client.fullname ||
    `${client.first_name || ""} ${client.last_name || ""}`.trim() ||
    `Клієнт #${client.id}`;
  const typeLabel =
    client.type === "both"
      ? "покупець/продавець"
      : client.type === "buyer"
        ? "покупець"
        : client.type || "";
  return typeLabel ? `${name} (${typeLabel})` : name;
};
